import { useState } from "react";
import { toast } from "sonner";
import {
  downloadClinicalExamPdf,
  downloadScreeningReportPdf,
} from "../../infrastructure/repositories/patientReportRepository";

export const useDownloadAssessmentReports = () => {
  const [reportLoading, setReportLoading] = useState(false);
  const [clinicalExamLoading, setClinicalExamLoading] = useState(false);

  const downloadBlob = async (
    loader: (loading: boolean) => void,
    download: (patientId: string, assessmentId: string) => Promise<{ blob: Blob; filename: string }>,
    errorMessage: string,
    patientId: string,
    assessmentId: string,
  ) => {
    loader(true);
    try {
      const { blob, filename } = await download(patientId, assessmentId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(errorMessage);
      throw error;
    } finally {
      loader(false);
    }
  };

  const downloadReport = async (patientId: string, assessmentId: string) =>
    downloadBlob(
      setReportLoading,
      downloadScreeningReportPdf,
      "Failed to download screening report PDF",
      patientId,
      assessmentId,
    );

  const downloadClinicalExam = async (patientId: string, assessmentId: string) =>
    downloadBlob(
      setClinicalExamLoading,
      downloadClinicalExamPdf,
      "Failed to download clinical exam PDF",
      patientId,
      assessmentId,
    );

  return {
    downloadReport,
    downloadClinicalExam,
    loading: reportLoading,
    reportLoading,
    clinicalExamLoading,
  };
};

export const useDownloadPatientReport = useDownloadAssessmentReports;
